import { css } from '@emotion/react'

import * as styles from '@twisto/styles'

export const description = css`
  ol {
    list-style-type: none;
    line-height: inherit;
  }

  & > ol {
    padding-left: 0;
    counter-reset: item;

    & > li {
      margin-bottom: ${styles.size[8]};

      &:before {
        content: counter(item, lower-alpha) ') ';
        counter-increment: item;
        font-weight: 500;
      }

      & > ol {
        padding-left: 1em;
        counter-reset: item2;

        & > li:before {
          content: counter(item2) ') ';
          counter-increment: item2;
          font-weight: 500;
        }
      }
    }
  }
`
